<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="200"
          height="150"
          class="iconMargin"
          src="../assets/czaszkowa.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis2 }}
        </span>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis3 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>
    <p class="paragraph">
      <b>{{ opis4 }}</b>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Terapia czaszkowo-krzyżowa",
      wskazania: [
        "zespoły bólowe: bóle i zawroty głowy, migreny, bóle kręgosłupa, stawów kończyn,",
        "zespoły neurologiczne: mrowienia i cierpnięcia kończyn, rwa kulszowa, udowa, ramienna,",
        "problemy stawu skroniowo-żuchwowego,",
        "zespoły o charakterze psychicznym: zaburzenia koncentracji, trudności w uczeniu się, zaburzenia snu, nerwice, ogólne złe samopoczucie bez konkretnych przyczyn, nadmierna ruchliwość dzieci i dorosłych,",
        "normalizacja napięcia mięśniowego (obniżanie spastyczności),",
        "koordynacja pracy układów nerwowego, powięziowego i mięśniowego,",
        "autyzm,",
        "problemy trawienne,",
        "anoreksja, bulimia,",
        "stanach po urazach.",
      ],
      opis1:
        "Terapia czaszkowo-krzyżowa jest delikatną i nieinwazyjną formą terapii manualnej, która poprawia naturalne mechanizmy autoregulacyjne człowieka. Poprzez odpowiednie ułożenie rąk fizjoterapeuty na ciele pacjenta istnieje możliwość oddziaływania na rytm produkcji i absorpcji płynu mózgowo-rdzeniowego. Czynność ta ma bezpośredni wpływ na sprawność pracy systemu czaszkowo-krzyżowego, czyli na układ nerwowy, mięśniowo-kostny, krążenia, limfatyczny, endokrynny oraz oddechowy. Terapia czaszkowo-krzyżowa wpływa na poprawę pracy wszystkich organów.",
      opis2:
        "Terapia polega na rozluźnieniu struktur poprzecznych, czyli powięzi w obrębie miednicy, przepony, górnego otworu klatki piersiowej i kości gnykowej. Rozluźnieniu podlegają także struktury pionowe, czyli stawy krzyżowo-biodrowe, połączenie lędźwiowo-krzyżowe i szczytowo-potyliczne.",
      opis3: "Podczas terapii mogą występować następujące odczucia u pacjenta:",
      opis4: "Czas trwania jednego zabiegu to 1-1,5 godziny",
      list: [
        "pulsowanie, mrowienie, drętwienie, pieczenie,",
        "skurcze mięśni (niekiedy bardzo silne) z drżeniem kończyn,",
        "uczucie intensywnego ciepła lub zimna,",
        '"kiwanie się", zawroty głowy, szumy w uszach, mroczki przed oczami – zaśnięcie lub senność w czasie zabiegu (bardzo często),',
        "wyzwolenie się silnych emocji (krzyk, płacz, łzawienie).",
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>